<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class=" mt-4">
        <Activation />
        <p class="font18bold breadcrums">
            <router-link to="/">Home</router-link> |
            <router-link to="/languages/clubs">Clubs</router-link> |
            <router-link to="#">Join </router-link>
        </p>

        <div class="_container mt-5 bg-black">
            <div class="row  row-h">
                <b-col v-if="club.images" cols="6" md="4" class="img-bg" v-bind:style='{ backgroundImage: "url(" + club.images + ")", }'>
                </b-col>
                <b-col cols="5" md="4" class="desktop mt-4 text-white">
                    <div class="font18 mb-2">
                        <b-icon class="mr-2" style="color:#F7B131" shift-v="1" font-scale="0.7" icon="clipboard"></b-icon> {{club.club_name}}
                    </div>
                    <p class="font14 text-capitalize">
                        <b-icon class="mr-2" style="color:#F7B131" shift-v="1" font-scale="1" icon="clock-history"></b-icon> {{club.status}}
                    </p>
                    <p class="font14">
                        <b-icon class="mr-2" style="color:#F7B131" shift-v="-2" font-scale="1" icon="calendar-date"></b-icon> {{club.start_day | moment("MM/DD/YYYY")}} {{club.start_time}}
                    </p>
                    <p class="font14">
                        <b-icon class="mr-2" style="color:#F7B131" shift-v="1" font-scale="1" icon="clipboard"></b-icon> {{club.club_language}}
                    </p>
                    <p class="font14">
                        <b-icon class="mr-2" style="color:#F7B131" shift-v="-2" font-scale="1" icon="wallet2"></b-icon> {{club.currency == null ? ' ': club.currency}} {{club.amount == null ? 'Free': club.amount}}
                    </p>
                </b-col>
                <b-col cols="6" md="4" class="mt-1 text-white">
                    <button @click="openBookModal" class="mt-2 btn btn-warning">Join
                        <b-icon scale="0.9" icon="arrow-right"></b-icon>
                    </button>
                  
                    <div class="mt-3">
                        <span class="font12">Share to social media</span> <br>
                        <facebook class="mr-2" :title="club.club_name" :url="url" scale="2" />
                        <twitter class="mr-2" :url="url" scale="2" />
                        <whats-app :url="url" scale="2" />
                    </div>
                    <div class="desktop mt-3">
                        <button class="mt-2 btn btn-danger">
                            <a target="_blank" :href="googleUrl" class="text-white font12"> + <b-icon icon="google"></b-icon>-calendar</a>
                        </button>
                        <button class="ml-2 mt-2 btn btn-info">
                            <a target="_blank" :href="officeUrl" class="text-white font12"> + <b-icon icon="grid-fill"></b-icon>-calendar</a>
                        </button>
                    </div>

                </b-col>

            </div>

        </div>
        <b-row class="inst-details mt-n2 bg-white text-center">
            <b-col cols="12" md="4" @click="showHost" :class="isHost == true ? 'active':''" class="inner-header-box">
                <div>
                    <b-icon shift-v="2" icon="person"></b-icon> About Host
                </div>
            </b-col>
            <b-col cols="12" md="4" @click="showMembers" :class="isMembers == true ? 'active':''" class="inner-header-box">
                <div>
                    <b-icon shift-v="1" icon="people"></b-icon> Meet the Members
                </div>
            </b-col>
            <b-col cols="12" md="4" @click="showClub" :class="isDetails == true ? 'active':''" class="inner-header-box">
                <div>
                    <b-icon shift-v="2" icon="clipboard"></b-icon> Club Description
                </div>
            </b-col>

        </b-row>
        <div v-if="isHost" class="card-no-shadow row p-2 p-3-md mr-4 ml-4 mt-4 profile-contain ">
            <b-col cols="12" md="8">
                <div class="row p-3-md">
                    <b-col cols="4" v-if="club.host.gender">
                        <p class="font14">Gender</p>
                        <p class="font16 text-capitalize">
                            <b-icon font-scale="0.9" icon="person"></b-icon> {{club.host.gender}}
                        </p>
                    </b-col>
                    <b-col cols="4">
                    </b-col>
                    <b-col cols="4" v-if="club.host.nationality">
                        <p class="font14">Nationality</p>
                        <p class="font16">
                            <b-icon font-scale="0.9" icon="globe"></b-icon> {{club.host.nationality.name}}
                        </p>
                    </b-col>
                </div>
                <div class="row p-3-md">
                    <b-col cols="8" v-if="club.host.state_residence">
                        <p class="font14">State</p>
                        <p class="font16">
                            <b-icon font-scale="0.9" icon="globe"></b-icon> {{club.host.state_residence}}
                        </p>
                    </b-col>
                    <b-col cols="4" v-if="club.host.country_residence">
                        <p class="font14">Country Residence</p>
                        <p class="font16">
                            <b-icon font-scale="0.9" icon="globe"></b-icon> {{club.host.country_residence}}
                        </p>
                    </b-col>

                </div>
                <div class="row p-3-md">
                    <b-col cols="8" v-if="club.host.interests">
                        <p class="font14">Occupation</p>
                        <p class="font16">
                            <b-icon font-scale="0.9" icon="bag"></b-icon> {{club.host.interests}}
                        </p>
                    </b-col>
                    <b-col cols="4">
                        <p class="font14">Joined</p>
                        <p class="font16">
                            <b-icon font-scale="0.9" icon="clock"></b-icon> {{club.created_at | moment("MM/DD/YYYY")}}
                        </p>
                    </b-col>

                </div>
            </b-col>
            <b-col cols="12" md="4" class="profile-contain">
                <div class="text-center">
                    <img :src="club.host.photo_full ? club.host.photo_full : this.defaultImage" style="" class="p-3" alt="">
                    <div class="mt-3">{{club.host.first_name}} </div>
                    <b-form-rating readonly show-value inline size="sm" v-model="club.host.rating"></b-form-rating>
                    <p class="font14">
                        {{club.host.bio}}
                    </p>
                    <button @click="openRatingModal" class="btn btn-secondary">
                        <b-icon font-scale="0.99" icon="heart"></b-icon> Rate
                    </button>
                </div>
            </b-col>
        </div>
        <div v-if="isMembers" class="card-no-shadow p-3 mr-4 ml-4 mt-4">
            <div class="row justify-content-between">
                <p class="font12" style="color:#565C63">
                    Club Members
                </p>
            </div>
            <div v-if="club.club_members.length > 0">
                <p class="font16" style="color:#565C63" v-for="(member, index) in club.club_members" :key="index">
                    <b-icon font-scale="1" class="mr-2" icon="person"></b-icon>
                    <router-link class="text-black" :to="{ name: 'public-profile', params: {id: member.user_id }}"> {{member.first_name}} {{member.last_name}}
                    </router-link>
                </p>
            </div>
            <p v-if="club.club_members.length == 0">
                No club members yet
            </p>

        </div>
        <b-row v-if="isDetails" class="card-no-shadow p-3 mr-4 ml-4 mt-4">
            <b-col cols="12" md="4">
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold">Club Name : </span>{{club.club_name}}
                </p>
                <p v-if="club.region" class="font12 text-capitalize" style="color:#565C63">
                    <span class="font-weight-bold"> Region </span>: {{club.region}}
                </p>
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold"> Cost:</span> <span class="culture-primary font-weight-bold">{{club.currency == null ? ' ': club.currency}} {{club.amount == null ? 'Free': club.amount}}</span>
                </p>
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold"> Moderator Name </span>: {{club.moderator_name}}
                </p>
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold"> Address </span>: {{club.address}}
                </p>
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold"> Start Day </span>: {{club.start_day | moment("MM/DD/YYYY")}}
                </p>
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold"> End Day </span>: {{club.end_day | moment("MM/DD/YYYY")}}
                </p>

            </b-col>
            <b-col cols="12" md="4">
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold"> Topic </span> : {{club.discussion_topic}}
                </p>
                <p class="font14 text-capitalize" style="color:#565C63">
                    <span class="font-weight-bold"> Member Category </span> : {{club.member_category}}
                </p>
                <p class="font14 text-capitalize" style="color:#565C63">
                    <span class="font-weight-bold"> Member Gender </span>: {{club.member_gender}}
                </p>
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold"> Member Limit </span> : {{club.member_limit}} people
                </p>
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold"> Start Time </span> : {{club.start_time}}
                </p>
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold"> End Time </span> : {{club.end_time}}
                </p>
            </b-col>
            <b-col cols="12" md="4">
                <p class="font14 text-capitalize" style="color:#565C63">
                    <span class="font-weight-bold"> Attendance mode </span>: {{club.attendance_mode == 'physical' ? 'In person' : 'Online'}}
                </p>
                <p class="font14 text-capitalize" style="color:#565C63">
                    <span class="font-weight-bold"> Status : </span> <span class="culture-primary text-capitalize font-weight-bold"> {{club.status}}</span>
                </p>
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold"> For Students from </span>: {{club.member_nationality ? club.member_nationality: 'Any Country'}}
                </p>
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold"> Age Limit </span> : {{club.age_limit}} years and over
                </p>
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold"> Duration </span>: {{club.duration}}
                </p>

            </b-col>
            <b-col cols="12">
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold"> Description </span>
                     <span v-html="club.club_description"></span>
                </p>
            </b-col>
            <b-col cols="12" class="mobile">
                <button class="mt-2 btn btn-outline-danger">
                    <a target="_blank" :href="googleUrl" class="text-danger font12"> + <b-icon icon="google"></b-icon>-calendar</a>
                </button>
                <button class="ml-2 mt-2 btn btn-outline-info">
                    <a target="_blank" :href="officeUrl" class="text-info font12"> + <b-icon icon="grid-fill"></b-icon>-calendar</a>
                </button>

            </b-col>
        </b-row>

    </b-container>
    <b-modal id="enrol-club" centered title="Message to host" hide-footer>
        <div class="text-center">
            <b-form-group class="col-md-12 mt-2 mb-4" label-for="course_description">
                <textarea style="height:auto !important;" required v-model="message" rows="7" placeholder="Any message to the host?" class="custome-card form-control"></textarea>
            </b-form-group>
            <button @click="enrol" class="btn btn-warning btn-below">
                {{sendbtnText}}
                <b-icon font-scale="0.99" icon="arrow-right"></b-icon>
            </button>
        </div>

    </b-modal>
    <b-modal id="rate-host" centered title="Rate Host" hide-footer>
        <div class="text-center">
            <p class="rating-title">{{club.rating}}</p>
            <p>Total Avg. Ratings</p>
            <b-form-rating class="star-icon mb-3" show-value size="lg" v-model="club.host.rating"></b-form-rating>
            <button @click="rateHost(club)" class="btn btn-warning btn-below">
                <b-icon font-scale="0.99" icon="heart"></b-icon> Rate Now
            </button>
        </div>

    </b-modal>
    <Footer />
</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";
import {
    Facebook,
    Twitter,
    WhatsApp
} from "vue-socialmedia-share";

import axios from "axios";
import {
    getBaseUrl
} from "../../../../utils/common";
const base_url = getBaseUrl();
export default {
    name: 'club-details',
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        Facebook,
        WhatsApp,
        Twitter,
        Activation,
        Footer
    },
    metaInfo() {
        return {
            title: this.club.club_name,
            meta: [{
                    name: 'description',
                    content: this.club.club_description
                },
                {
                    property: "og:title",
                    content: this.club.title
                },
                {
                    property: "og:image",
                    content: this.club.images
                },
                {
                    property: 'og:site_name',
                    content: 'Culture Square'
                },
                {
                    property: 'og:type',
                    content: 'website'
                },
                {
                    name: 'robots',
                    content: 'index,follow'
                }
            ]
        }
    },
    data: function () {
        return {
            headerText: "Language Clubs",
            subText: "Connect with people round the globe by joining a language club",
            fadedText: "Language",
            searchInput: {
                name: '',
                flag: ''
            },
            defaultImage: require('../../../assets/images/prof-img.png'),
            isMembers: false,
            isHost: false,
            isDetails: true,
            languages: [],
            countryAdded: [],
            club: {
                host: {}
            },
            message: '',
            booking: {},
            sendbtnText: 'Join',
            url: '',
            googleUrl: "",
            officeUrl: ""
        }
    },
    mounted() {
        this.getClubDetails();
    },
    computed: {
        isLoggedIn: function () {
            return this.$store.getters.isLoggedIn;
        },
       
    },
    methods: {
        gcalUrl (club) {
            const formated_start_date = club.start_day ? Date.parse(club.start_day + ' ' + club.start_time): null;
            const formated_end_date = Date.parse(club.end_day + ' ' + club.end_time)
            console.log('format date', formated_start_date);
            const start_date = new Date(formated_start_date) ? new Date(formated_start_date).toISOString().replace(/-|:|\.\d+/g, '') : null;
            const end_date = new Date(formated_end_date) ? new Date(formated_start_date).toISOString().replace(/-|:|\.\d+/g, '') : null;
            this.googleUrl = `http://www.google.com/calendar/render?action=TEMPLATE&trp=false&text=${club.club_name}&location=${club.address}&details=${club.club_description}&dates=${start_date}/${end_date}`
        },
        officeCalUrl(club) {
            const formated_start_date = Date.parse(club.start_day + ' ' + club.start_time)
            const formated_end_date = Date.parse(club.end_day + ' ' + club.end_time)
            const start_date = new Date(formated_start_date) ? new Date(formated_start_date).toISOString().replace(/-|:|\.\d+/g, '') : null;
            const end_date = new Date(formated_end_date) ? new Date(formated_start_date).toISOString().replace(/-|:|\.\d+/g, '') : null;
            this.officeUrl =  `https://outlook.office.com/owa/?path=/calendar/action/compose&rru=addevent&subject=${club.club_name}&location=${club.address}&body=${club.club_description}&startdt=${start_date}&enddt=${end_date}`

        },
        openBookModal() {
            if (!this.isLoggedIn) {
                this.$router.push({
                    name: "sign-in",
                    query: {
                        redirect: `/languages/clubs/${this.$route.params.id}/details`,
                    },
                });
            } else {
                this.$bvModal.show("enrol-club")
            }
        },
        async queryLanguage() {
            const name = this.searchInput.name;
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/languages?name=${name}`,
                    method: "GET",
                })
                this.languages = resp.data.data;
            } catch (error) {
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        showHost() {
            this.isHost = true;
            this.isMembers = false;
            this.isDetails = false;

        },
        showMembers() {
            this.isHost = false;
            this.isMembers = true;
            this.isDetails = false;

        },
        showClub() {
            this.isHost = false;
            this.isMembers = false;
            this.isDetails = true;

        },
        openRatingModal() {
            this.$bvModal.show("rate-host")
        },
        async getClubDetails() {
            const id = this.$route.params.id;
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/languageclubs/${id}`,
                    method: "GET",
                })
                this.club = resp.data.data;
                this.url = window.location.href;
                this.officeCalUrl(this.club)
                this.gcalUrl(this.club)
            } catch (error) {
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async enrol() {
            this.sendbtnText = "Joining..."
            this.booking.event_id = this.$route.params.id;
            this.booking.message_to_host = this.message
            try {
                this.sendbtnText = "Joining..."
                await axios({
                    url: `${base_url}/api/v2/eventactions?action=booking&section=club`,
                    data: this.booking,
                    method: "POST",
                })
                this.sendbtnText = "Join"
                this.$router.push("/languages/clubs/bookings");
            } catch (error) {
                this.sendbtnText = "Join"
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }

        },
        async rateHost(club) {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/eventactions?action=rate`,
                    data: {
                        event_id: club.club_id,
                        rating: club.host.rating
                    },
                    method: "POST",
                })
                this.$bvModal.hide('rate-host')
                this.$root.$refs.A.makeToast('success', resp.data.message)

            } catch (error) {
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }

        },

    }

}
</script>

<style scoped>
.row {
    margin-left: 0 !important;
}

p.breadcrums a {
    color: #565C63 !important
}

._container {
    padding: 10px 10px 20px;
}

.img-bg {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

.profile-contain img {
    border-radius: 50%;
    height: 110px;
    width: 110px
}

.bordered {
    border-left: 2px solid #ccc;
}

.card-no-shadow {
    border: 1px solid #ccc
}

.time-frame {
    background: rgba(247, 177, 49, 0.15);
    border-radius: 16px;
    padding: 2px 13px;
    text-transform: uppercase;
    margin-top: 10px
}

.inst-details {
    box-shadow: 2px 6px 19px rgba(0, 0, 0, 0.15);
    border-radius: 16px 16px 0px 0px;
    padding: 10px;
}

.btn-grey {
    background: #565C63 !important;
    border-radius: 4px !important;
    color: #fff !important
}

.light-input-container {
    border: 1px solid rgba(86, 92, 99, 0.54);
    padding: 10px;
    border-radius: 5px;
    background: #fff;
}

.custom-select {
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
    border-radius: 8px;
    padding: 20px 16px;
    border: none;
    height: 59px;
}

.custom-input-group {
    box-shadow: none !important;
    margin: 0 !important
}

.custom-input-group .input-group-prepend {
    padding-top: 18px !important;
}

.btn-culture {
    padding: 10px 60px !important;
}

.form-control {
    height: calc(2em + 0.75rem + 15px) !important;

}

.input-group {
    margin: 0
}

.form-control:focus {
    outline: none !important;
    box-shadow: none !important;
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.bi-search {
    margin-right: 1rem;
}

.custom-select .caret {
    padding-right: 10px;
}

.custom-control {
    height: calc(1.5em + 0.75rem + 15px) !important;

}

.btn-box {
    margin: 14px 0
}

.head-box {
    margin: 35px auto auto;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    border-radius: 5px;
    background-color: #F6F7F7;
}

.inner-header-box {
    border-radius: 16px;
    cursor: pointer;
}

.inner-header-box:hover>div {
    background: #000;
    color: #fff;
    border-radius: 4px;
    transition: ease-in 0.3s;

}

.inner-header-box.active {
    background: #fff;
    color: #fff;
}

.inner-header-box>div {
    margin: 10px;
    background: #fff;
    padding: 15px;
    border-radius: 4px;
}

.inner-header-box.active>div {
    margin: 10px;
    background: #000;
    padding: 15px;
    border-radius: 4px;
}

.inner-header-box:hover .b-icon.bi,
.inner-header-box.active .b-icon.bi {
    color: rgba(247, 177, 49, 1)
}

.header-box {
    padding: 20px;
    border-radius: 4px;
    cursor: pointer;
}

.font18bold {
    font-size: 18px;
    font-weight: 500;
}

.font24bold {
    font-size: 24px;
    font-weight: 500;
}

.custom-notify {
    border-radius: 8px;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
    transition: all 0.5s ease-in-out !important;
}

.country-list-span {
    background: #000;
    color: #fff;
    padding: 15px 30px;
    border-radius: 8px;
    margin-right: 25px;
}

.autocomplete-list {
    top: 62px !important;
    text-align: left !important;
    width: 100% !important
}

.autocomplete-list ul li {
    border: none !important;
    transition: all 0.1s ease-in-out !important;
}

.autocomplete-list ul li:hover {
    background: #F6F7F7;
}

.country-list-span span:nth-child(2) {
    cursor: pointer
}

.autocomplete-list img,
.country-list-span img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
}
</style>
